module.exports = __webpack_public_path__ + "img/shot_tx19121302.31f72c52.jpg";